import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

'use strict';
const Animations = {
	init: function() {
		const fadeIn = document.querySelectorAll('.fade-in');

		ScrollTrigger.config({lagSmoothing: 0.1});

		ScrollTrigger.batch(fadeIn, {
			onEnter: (batch) => {
				batch.forEach((el) => {
					const delay = el.dataset.delay ? parseFloat(el.dataset.delay) : 0;
					gsap.to(el, {opacity: 1, y: 0, duration: 1, delay});
				});
			},
			once: true,
		});
	}
};

export default Animations;
